<template>
  <div class="button-body">
    <div class="buttons">
      <button class="button" @click="handleClick" :style="[disable ? { background: '#c9c9c9', color: '#808080'} : '']">
        {{ title }}
        <span style="float: right">></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DbsButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean
    }
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss">
.button-body .buttons .button {
  display: block;
  width: 100%;
  background-color: #ffffff;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  text-decoration: none;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
